<template>
  <FlexColumn :space="0">
    <Label text="性別" class="mb-1" bold />
    <SimpleSelectField
        :value="value"
        :items="items"
        class="mt-0 pt-0"
        @input="handleInput"
    />
  </FlexColumn>
</template>

<script>
import SimpleSelectField from "../atoms/SimpleSelectField";
import {mapGetters} from "vuex";
import Label from '../atoms/Label'
import FlexColumn from '../atoms/FlexColumn'

export default {
  name: "ApplicantSearchGenderSelect",
  components: { FlexColumn, Label, SimpleSelectField},
  props: {
    value: {
      type: Number
    }
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    items() {
      return [{
        value: undefined,
        label: "指定なし"
      }].concat(this.consts.gender)
    }
  },
  methods: {
    handleInput(value) {
      this.$emit("input", value)
    }
  }
}
</script>

<style scoped>

</style>